if (window.matchMedia('(pointer: coarse)').matches) {
  document.documentElement.classList.add('touchevents');
} else {
  document.documentElement.classList.add('no-touchevents');
}
